// Font catalog surfaced in the Settings drawer. Each entry maps to a
// CSS font-family stack the MUI theme typography uses.
//
// All fonts must:
//  - Render Latin glyphs cleanly.
//  - Render Arabic glyphs cleanly (RTL is a first-class locale).
//
// Web fonts are loaded via <link> tags in `public/index.html`. Adding a
// new entry here requires adding the matching <link> too — otherwise
// the browser falls back to the system stack silently.

export const FONTS = {
    publicSans: {
        name: 'Public Sans',
        labelAr: 'Public Sans',
        // Public Sans has no Arabic glyphs; pair it with Cairo as the
        // Arabic fallback so AR text stays legible.
        stack: '"Public Sans", "Cairo", system-ui, -apple-system, sans-serif',
    },
    inter: {
        name: 'Inter',
        labelAr: 'Inter',
        stack: '"Inter", "Cairo", system-ui, -apple-system, sans-serif',
    },
    dmSans: {
        name: 'DM Sans',
        labelAr: 'DM Sans',
        stack: '"DM Sans", "Cairo", system-ui, -apple-system, sans-serif',
    },
    nunitoSans: {
        name: 'Nunito Sans',
        labelAr: 'Nunito Sans',
        stack: '"Nunito Sans", "Cairo", system-ui, -apple-system, sans-serif',
    },
    cairo: {
        name: 'Cairo',
        labelAr: 'Cairo',
        stack: '"Cairo", "Public Sans", system-ui, -apple-system, sans-serif',
    },
    tajawal: {
        name: 'Tajawal',
        labelAr: 'Tajawal',
        stack: '"Tajawal", "Public Sans", system-ui, -apple-system, sans-serif',
    },
    ibmPlexSansArabic: {
        name: 'IBM Plex Sans Arabic',
        labelAr: 'IBM Plex Sans Arabic',
        stack: '"IBM Plex Sans Arabic", "Public Sans", system-ui, -apple-system, sans-serif',
    },
    notoSansArabic: {
        name: 'Noto Sans Arabic',
        labelAr: 'Noto Sans Arabic',
        stack: '"Noto Sans Arabic", "Public Sans", system-ui, -apple-system, sans-serif',
    },
    readexPro: {
        name: 'Readex Pro',
        labelAr: 'Readex Pro',
        stack: '"Readex Pro", "Public Sans", system-ui, -apple-system, sans-serif',
    },
};

export const FONTS_LIST = Object.keys(FONTS);

export const DEFAULT_FONT = 'publicSans';

export const getFont = (key) => FONTS[key] || FONTS[DEFAULT_FONT];
